import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useGraphToken } from "./useGraphToken";

async function getUsers(graphToken: string, by_department = false) {
  const fields =
    "id,displayName,userPrincipalName,mail,givenName,surname,jobTitle,mobilePhone,department";
  const users: any[] = [];
  let response = (
    await axios.get(
      `https://graph.microsoft.com/v1.0/users?$top=999&$select=${fields}`,
      {
        headers: {
          Authorization: `Bearer ${graphToken}`,
        },
      }
    )
  ).data;
  users.push(...response.value);
  while (response["@odata.nextLink"]) {
    response = (
      await axios.get(response["@odata.nextLink"], {
        headers: {
          Authorization: `Bearer ${graphToken}`,
        },
      })
    ).data;
    users.push(...response.value);
  }
  if (by_department) {
    let departments: any = {};
    users.forEach((user) => {
      if (user.department) {
        departments[user.department] = departments[user.department] || [];
        departments[user.department].push(user);
      }
    });
    return departments;
  }

  return users;
}

export const useEntraUsers = () => {
  const { data: graphToken } = useGraphToken();
  return useQuery({
    queryKey: ["entraUsers"],
    queryFn: () => getUsers(String(graphToken), false),
  });
};
